import MyPolicies from './MyPolicies';
export default MyPolicies;
